import React, { Component } from "react";
import { connect } from "react-redux";
import ContentHeader from "./ContentHeader";
import { list, create, update } from "../actions";
import NoticeModal from "./NoticeModal";
import { editNotice, newNotice, hideModal } from "../actions/notices";
import NoticesList from "./NoticesList";

class Notices extends Component {

  componentDidMount() {
    this.props.fetchNotices();
  }

  onItemEdit = (id) => {
    this.props.editNotice({id})
  }

  render() {
    return (
      <div>
        <ContentHeader title="Notices">
          <span className="pull-right">
            <button className="btn btn-primary" onClick={this.props.newNotice}>
              Add Notice
            </button>
          </span>
        </ContentHeader>
        <NoticesList notices={this.props.notices} onItemEdit={this.onItemEdit} />
        <NoticeModal
          showModal={this.props.showNoticeModal}
          hideModal={this.props.hideModal}
          saveNotice={this.props.saveNotice}
          currentNotice={this.props.currentNotice}
          noticeCategories={this.props.noticeCategories}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { list, currentNotice, showNoticeModal } = state.notices;

  return {
    notices: list,
    currentNotice,
    showNoticeModal,
    noticeCategories: state.noticeCategories.list
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchNotices() {
      dispatch(list("notices"));
    },
    newNotice(noticeDetails) {
      dispatch(newNotice(noticeDetails));
    },
    editNotice(noticeDetails) {
      dispatch(editNotice(noticeDetails));
    },
    hideModal() {
      dispatch(hideModal());
    },
    saveNotice(data) {
      if (data.id) {
        dispatch(update("notice", data));
      } else {
        dispatch(create("notice", data));
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notices);



// WEBPACK FOOTER //
// ./src/components/Notices.js